import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const YANDEX_METRIKA_ID = 103479471;

export default function YandexMetrikaTracker() {
    const location = useLocation();

    useEffect(() => {
        if (typeof window.ym === "function") {
            window.ym(YANDEX_METRIKA_ID, "hit", location.pathname + location.search, {
                title: document.title
            });
        }
    }, [location]);

    return null;
}
